import {
  BranchRuleKind,
  BranchTargetKind,
  RatingOperator,
} from '@/contracts/enums/branching';

export interface BranchRuleTarget {
  kind: BranchTargetKind;
  childId?: string;
}

export interface ChoiceBranchRules {
  kind: BranchRuleKind.Choice;
  choiceTargets: Record<string, BranchRuleTarget>;
}

export interface BooleanBranchRules {
  kind: BranchRuleKind.Boolean;
  trueTarget: BranchRuleTarget;
  falseTarget: BranchRuleTarget;
}

export interface RatingBranchCondition {
  operator: RatingOperator;
  value: number;
  target: BranchRuleTarget;
}

export interface RatingBranchRules {
  kind: BranchRuleKind.Rating;
  conditions: RatingBranchCondition[];
}

export const MATRIX_ANY_ROW = '*';

export interface MatrixValueCondition {
  column: string;
  target: BranchRuleTarget;
}

export interface MatrixBranchRules {
  kind: BranchRuleKind.Matrix;
  row: string;
  conditions: MatrixValueCondition[];
}

export type BranchRules =
  | ChoiceBranchRules
  | BooleanBranchRules
  | RatingBranchRules
  | MatrixBranchRules;
